export default function IosTimer() {
  return (
    <div
      className="ion-icon-ios-timer"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<path d="M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z
	 M150.5,150.5c2.6-2.3,119.9,84.9,119.9,84.9c1,0.7,1.6,1.5,2.2,2.2c5,4.6,8.2,11,8.2,18.3c0,13.7-11.1,24.9-24.9,24.9
	c-7.8,0-14.7-3.7-19.3-9.4c-0.4-0.4-0.8-0.7-1.1-1.1C235.6,270.4,148,152.9,150.5,150.5z M256.1,447.2
	c-105.7,0-191.4-85.7-191.4-191.4c0-52.8,21.4-100.7,56-135.3l11.8,11.8c-31.6,31.6-51.2,75.3-51.2,123.5
	c0,96.3,78.4,174.7,174.7,174.7s174.5-78.4,174.5-174.7c0-90.3-70.5-165.1-158.5-174V160h-16V64.4c105.7,0,191.5,85.7,191.5,191.4
	C447.5,361.5,361.7,447.2,256.1,447.2z"/>
</svg>
`,
      }}
    />
  )
}
